


















































































import { snakeCase } from 'lodash'
import Vue from 'vue'
import i18n from 'vue-i18n'
import { Component, Prop } from "vue-property-decorator"
import { DirectiveBinding } from 'vue/types/options'

import { UserInfo } from '../../../../../../../../../../models/getUserInfo/GetUserInfo'
import FileApi from "../../../../../../../../../File/logic/file-api";
import { RowButtonView } from '../../../../../../../components'
import CustomEditor from '../../../../../../Editor/CustomEditor'
import UsersInfoHelper from '../../../../../../Helpers/UserInfoHelper'
import { ActionNode } from '../../../logic/ActionNode'
import { NotifyUsersActionProxy } from '../../../logic/Actions/NotifyUsersAction/NotifyUsersActionProxy'

@Component({
  data() {
    return {
      snakeCase,
    }
  },
  components: {
    RowButtonView,
  }
})
export default class NotifyUsersAction extends Vue {
  @Prop() action!: NotifyUsersActionProxy

  @Prop() i18n!: i18n

  @Prop() target!: string

  @Prop() node!: ActionNode

  @Prop() bindSocket!: DirectiveBinding

  @Prop() editor!: CustomEditor

  fileApi = new FileApi()

  get users(): Array<UserInfo> {
    const result: Array<UserInfo> = []

    this.action.action.users.forEach((u) => {
      const info = UsersInfoHelper.getUser(u)
      if (info) {
        result.push(info)
      }
    })

    return result
  }
}
